import login from "./login.json";
import home from "./home.json";
import menu from "./menu.json";
import header from "./header.json";
import users from "./users.json";
import buttons from "./buttons.json";
import tasks from "./tasks.json";
import errors from "./errors.json";
import accesscontrol from "./accesscontrol.json";
import table from "./table.json";
import forms from "./forms.json";
import banners from "./banners.json";
import footer from "./footer.json";
import accessibility from "./accessibility.json";
import termsOfUse from "./terms-of-use.json";
import error from "./error.json";
import results from "./results.json";
import events from "./events.json";
import result_units from "./result-units.json";
import input_units from "./input-units.json";
import faq from "./faq.json";
import answers from "./answers.json";
import captcha from "./captcha.json";

const translationFR = {
  ...login,
  ...home,
  ...header,
  ...menu,
  ...users,
  ...buttons,
  ...tasks,
  ...errors,
  ...accesscontrol,
  ...table,
  ...forms,
  ...banners,
  ...events,
  ...input_units,
  ...result_units,
  ...faq,
  ...footer,
  ...accessibility,
  ...termsOfUse,
  ...results,
  ...error,
  ...answers,
  ...captcha,
};

export default translationFR;
